<template>
  
  <nna-container>

    <div class="align-middle">  
      
      <nna-logo size="large" secondary class="align-middle align-center" />

      <form novalidate class="md-layout" @submit.prevent="onSubmitForm">
          
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-20" v-show="showPrefix">
            <md-field>
              <label for="telephone">Telefono</label>
              <md-select v-model="form.prefix" name="prefix" id="prefix">
                <md-option value="+39">+39</md-option>
                <md-option value="+44">+44</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-field :class="getValidationClass('username')">
              <label for="username" v-show="showUsernameLabel">Telefono o email</label>
              <label for="username" v-show="showTelephone">Email</label>
              <md-input name="username" id="username" autocomplete="username" v-model="form.username" :disabled="sending" />
              <span class="md-error" v-if="!$v.form.username.required">Inserisci la tua username</span>
              <span class="md-error" v-else-if="!$v.form.username.email">Username non valida</span>
            </md-field>
          </div>
        </div>

        <md-field :class="getValidationClass('password')">
          <label for="first-name">Password</label>
          <md-input name="password" id="password" autocomplete="password" v-model="form.password" :disabled="sending" type="password"/>
          <span class="md-error" v-if="!$v.form.password.required">Inserisci la tua password</span>
          <span class="md-error" v-else-if="!$v.form.password.minlength">Password non valido</span>
        </md-field>

        <md-button type="submit" class="md-raised md-primary" md-align="center">Accedi</md-button>

      </form>

      <md-button class="md-raised md-primary" md-align="center" @click="$router.push({ name: 'signup' })">Registrazione</md-button>
      <md-button  md-align="center" @click="$router.push({ name: 'auth.recover' })">Recupero Password</md-button>

      <br /><br />

      <a md-align="center" @click="$router.push({ name: 'home' })">Esplora senza registrazione</a>
        
    </div>

  </nna-container>

</template>

<script>
import CMM from '@nonameapp-core'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Auth',
  mixins: [
    CMM._mixins.form("auth")
  ],  
  data() {
    return {
      showTelephone: false,
      showEmail: false,
      showPrefix: false,
      form: {
        username: '',        
        password: '',
        prefix: '+39',
      }    
    }
  },
  watch: {
    'form.username': {
      handler(val){
        this.checkUserName(val)
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      register: 'auth/register',
      isAuthenticated: 'auth/isAuthenticated',
    }),
    showUsernameLabel() {
      return !this.showPrefix && !this.showTelephone
    }
  },
  methods: {
    ...mapActions({
      login: 'auth/login'
    }),
    async auth() {
      this.sending = true
      try { 
        this.form.showPrefix = this.showPrefix
        const { data } = await this.login(this.form)
        if(data.hcode === "ok") {
          this.sending = false
          this.clearForm()
          this.$router.push({ name: "home" })
          //this.$toasted.show("Loggato", { type: 'success' })
        } else {
          this.sending = false
          this.$toasted.show(data.msg, { type: 'error' })
        }        
     } catch (errors) {
       console.error("Error:", errors)
       this.sending = false
       this.$toasted.show('Qualcosa è andato storto!', { type: 'error' })
      }
    },
    onSubmitForm () {
      if(this.validateForm()) this.auth()
    },
    checkUserName (val) {       
      const email = this.regex.email;
      const phone = this.regex.phone;
      if(email.test(String(val).toLowerCase())) {
        this.showTelephone = true
        this.showEmail = false
        this.showPrefix = false
      }
      else if(phone.test(String(val).toLowerCase())) {
        this.showTelephone = false
        this.showEmail = true
        this.showPrefix = true
      }
      else {
        this.showTelephone = false
        this.showEmail = false
        this.showPrefix = false
      }
    }
  },
  mounted() {
    console.log(this.isAuthenticated)
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/auth/login/pages/Auth.vue